<template>
  <div>
    <h1>Votre identité</h1>
    <form @submit.prevent="handleSubmit">
      <FormInput
        id="register-first-name"
        v-model="form.firstName"
        label="Prénom"
        required
        @blur="$v.form.firstName.$touch()"
      >
        <template v-if="$v.form.firstName.$dirty" #error>
          <template v-if="!$v.form.firstName.required">Le prénom est obligatoire</template>
          <template v-else-if="$v.form.firstName.$invalid">Ce prénom est invalide</template>
        </template>
      </FormInput>
      <FormInput
        id="register-last-name"
        v-model="form.lastName"
        label="Nom"
        required
        @blur="$v.form.lastName.$touch()"
      >
        <template v-if="$v.form.lastName.$dirty" #error>
          <template v-if="!$v.form.lastName.required">Le nom est obligatoire</template>
          <template v-else-if="$v.form.lastName.$invalid">Ce nom est invalide</template>
        </template>
      </FormInput>

      <SignupButtons :can-be-submitted="!$v.$invalid" />
    </form>
  </div>
</template>

<script>
  import ButtonGreen from '@/components/ButtonGreen';
  import SignupButtons from '@/components/Signup/SignupButtons';
  import FormInput from '@/components/Form/FormInput';
  import { required } from '@byscripts/vuelidate/lib/validators';

  export default {
    name: 'SignupIdentity',
    components: { FormInput, SignupButtons, ButtonGreen },
    data() {
      return {
        form: {
          firstName: this.$store.state.signup.form.firstName,
          lastName: this.$store.state.signup.form.lastName,
        },
      };
    },
    validations: {
      form: {
        firstName: { required },
        lastName: { required },
      },
    },
    methods: {
      handleSubmit() {
        this.$v.$touch();

        if (this.$v.$invalid) {
          return this.$addError('Veuillez vérifier le formulaire');
        }

        this.$store.dispatch('signup/saveForm', { form: this.form });
        this.$store.dispatch('signup/goToNextStep');
      },
    },
  };
</script>

<style lang="scss" scoped>
  .form-input {
    margin-bottom: 3rem;
  }
  ::v-deep .signup-buttons.has-back-button{
    @include onMobile{
      column-gap: 3.7rem;
      justify-content: end;
      flex-wrap: wrap;
    }
  }
</style>
